import styled from 'styled-components';

export const RelatedOnRow = styled.div`
  display: flex;
`;
